export enum NotificationRelatedEntityTypeEnum {
  ProxyAdvice = 1,
  CallManagement = 2,
  ProjectActivity = 3,
  KeyEvent = 4
}
